var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHideVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hide-video_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1024 1024"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".hide-video_svg__st1{fill:none}.hide-video_svg__st3{fill:#35a4dd}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.1 250v547h596.3V624.4L294.1 250zM386 250l282.4 282.5V250z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M229.1 185h-157c-35.9 0-65 29.1-65 65v547c0 35.9 29.1 65 65 65h596.4c35.9 0 65-29.1 65-65V689.4l-65-65V797H72.1V250h222l-65-65z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9af17",
    d: "M41.7 9.2c-8.3 0-16.6 3.2-23 9.5C6 31.4 6 52 18.7 64.7l940.6 940.6c6.3 6.3 14.7 9.5 23 9.5s16.6-3.2 23-9.5c12.7-12.7 12.7-33.3 0-46L64.7 18.7c-6.3-6.3-14.7-9.5-23-9.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M399.9 185c-18 0-32.6 14.6-32.6 32.6s14.6 32.6 32.6 32.6 32.6-14.6 32.6-32.6-14.6-32.6-32.6-32.6zM668.4 185H495.3c-18 0-32.6 14.6-32.6 32.6 0 16.8 12.7 30.6 29 32.4 1.2.1 2.4.2 3.6.2s2.4-.1 3.6-.2h169.6v267.6c0 .3-.1.6-.1.9h.1v.6c.6 17.4 14.9 31.4 32.5 31.4 16.2 0 29.6-11.8 32.1-27.2h.2L945 303.6V747.8c.1 17.9 14.6 32.3 32.5 32.3 14.6 0 26.9-9.6 31-22.8 1-3.1 1.5-6.3 1.5-9.7v-1.7-442.3c0-26.5-16.1-50.4-40.7-60.3-7.9-3.2-16.1-4.7-24.3-4.7-17.3 0-34.3 6.9-46.8 19.9l-164.8 171V250c0-35.9-29.1-65-65-65z"
  })));
}

export default SvgHideVideo;